import { useEffect } from 'react';

import { IS_STAGING } from '@/env';

export default function GoogleButton() {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const isInBrowserState = typeof window !== 'undefined';

  return (
    <>
      <div
        data-auto_prompt='false'
        data-callback='onLoginWithGoogle'
        data-client_id={
          IS_STAGING
            ? '201895780642-ln00r1cev5fp6u3eqpq07olmi2dabmkl.apps.googleusercontent.com'
            : '201895780642-g4oj7hm4p3h81eg7b1di2l2l93k5gcm3.apps.googleusercontent.com'
        }
        data-context='signin'
        data-nonce=''
        data-ux_mode='popup'
        id='g_id_onload'
      />
      <div className='flex items-center justify-center font-bold gap-0.5 h-[44px] w-full'>
        <div
          className='g_id_signin'
          data-logo_alignment='center'
          data-shape='pill'
          data-size='large'
          data-text='signin_with'
          data-theme='outline'
          data-width={isInBrowserState && window.screen.width <= 768 ? 272 : 400}
        />
      </div>
    </>
  );
}
